import {
  FETCH_CALCULATOR_CONFIG_START,
  FETCH_CALCULATOR_CONFIG_COMPLETE,
  FETCH_CALCULATOR_CONFIG_ERROR,
  CALCULATE_RESULTS_START,
  CALCULATE_RESULTS_COMPLETE,
  CALCULATE_RESULTS_ERROR,
  CLEAR_CALCULATOR_ERROR,
} from './actions';

const initialState = {
  config: null,
  isConfigLoading: false,
  configError: undefined,

  calculationResult: null,
  isCalculateLoading: false,
  calculateError: undefined,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case FETCH_CALCULATOR_CONFIG_START:
      return {
        ...state,
        isConfigLoading: true,
        configError: undefined,
      };
    case FETCH_CALCULATOR_CONFIG_COMPLETE:
      return {
        ...state,
        config: payload.config,
        isConfigLoading: false,
        configError: undefined,
      };
    case FETCH_CALCULATOR_CONFIG_ERROR:
      return {
        ...state,
        configError: payload.error,
        isConfigLoading: false,
      };
    case CALCULATE_RESULTS_START:
      return {
        ...state,
        isCalculateLoading: true,
        calculateError: undefined,
      };
    case CALCULATE_RESULTS_COMPLETE:
      return {
        ...state,
        calculationResult: payload.result,
        isCalculateLoading: false,
        calculateError: undefined,
      };
    case CALCULATE_RESULTS_ERROR:
      return {
        ...state,
        calculateError: payload.error,
        isCalculateLoading: false,
      };
    case CLEAR_CALCULATOR_ERROR:
      return {
        ...state,
        configError: undefined,
        calculateError: undefined,
      };
    default:
      return state;
  }
};

export default reducer;
